module.exports = __webpack_public_path__ + "img/Gif_web5.d2a6944a.gif";